export default `float sdMandelbulb(vec3 p, int iterations, float power) {
    vec3 z = p;
    float dr = 1.0;
    float r = 0.0;

    for(int i = 0; i < iterations; i++) {
        r = length(z);

        
        if(r > 2.0) break;

        
        float theta = acos(z.z / r);
        float phi = atan(z.y, z.x);

        
        dr = pow(r, power - 1.0) * power * dr + 1.0;

        
        float zr = pow(r, power);
        theta = theta * power;
        phi = phi * power;

        
        z = zr * vec3(
            sin(theta) * cos(phi),
            sin(phi) * sin(theta),
            cos(theta)
        );

        
        z += p;
    }

    
    r = max(r, 1e-6); 
    return 0.5 * log(r) * r / dr;
}

float sdMandelbulbUniform(vec3 p, int maxIterations, float power) {
    return sdMandelbulb(p, maxIterations, power);
}

float sdMandelbulbAnimated(vec3 p, int iterations, float power, float time) {
    
    p = rotateY(p, time * 0.1);
    p = rotateX(p, sin(time * 0.05) * 0.3);

    return sdMandelbulb(p, iterations, power);
}

float sdMandelbulbScaled(vec3 p, int iterations, float power, float scale) {
    
    p /= scale;

    
    return sdMandelbulb(p, iterations, power) * scale;
}

float sdJulia(vec3 p, vec4 c, int iterations) {
    vec4 z = vec4(p, 0.0);
    float dr = 1.0;
    float r = 0.0;

    for(int i = 0; i < iterations; i++) {
        r = length(z);
        if(r > 2.0) break;

        
        dr = 2.0 * r * dr + 1.0;

        
        z = vec4(
            z.x*z.x - z.y*z.y - z.z*z.z - z.w*z.w,
            2.0*z.x*z.y,
            2.0*z.x*z.z,
            2.0*z.x*z.w
        ) + c;
    }

    r = max(r, 1e-6); 
    return 0.5 * log(r) * r / dr;
}`